import ModalManager from 'utils/modal_manager';
import './index.scss';

/**
 * Populate object for this modal accepts:
 *
 * {
 *   question [string] (optional) 
 *   ok [string] (optional)
 *   cancel [string] (optional)
 *   modalType [string] (optional)
 *   iconName [string] (optional - icon sufix - without .q-icon-)
 * }
 *
 */

// TODO: move this to modal manager if approved and update call below
class PromiseModal extends ModalManager {
  static modify(selector, modalType, iconName) {
    const $modalElement = selector.jquery ? selector : $(selector);
    const $modalIcon = $('.js-modal-icon', $modalElement);

    if (modalType) {
      $modalElement.attr('data-modal-type', modalType);
      $('.q-btn-ok', $modalElement)
        .removeClass('btn-default')
        .removeClass('btn-info')
        .removeClass('btn-success')
        .removeClass('btn-danger')
        .addClass(`btn-${modalType}`);
    }

    if (iconName) {
      $modalIcon.removeClass().addClass(`js-modal-icon q-icon q-icon-${iconName}`);
    }
  }
}

export default {
  call(populate, callback) {
    const modalSelector = '#js-promise-modal';
    const {modalType, iconName} = populate;

    PromiseModal.modify(modalSelector, modalType, iconName);
    PromiseModal.populate(modalSelector, populate);
    PromiseModal.open(modalSelector, callback);
  }
};
